import { render, staticRenderFns } from "./Surveys.vue?vue&type=template&id=7ec2998a&scoped=true"
import script from "./Surveys.vue?vue&type=script&lang=js"
export * from "./Surveys.vue?vue&type=script&lang=js"
import style0 from "./Surveys.vue?vue&type=style&index=0&id=7ec2998a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec2998a",
  null
  
)

export default component.exports